import { apiRequest } from "./CmnService";

export const changePasswordService = async (data, cb) => {
    return apiRequest("POST", "changePassword", data, cb);
}
export const ForgotPasswordService = async (data, cb) => {
    return apiRequest("POST", "forgot-password", data, cb);
}
export const ResetPasswordService = async (data, cb) => {
    return apiRequest("POST", "reset-password", data, cb);
}
export const SignupService = async (data, cb) => {
    return apiRequest("POST", "registration", data, cb);
}
export const OtpVerificationService = async (data, cb) => {
    return apiRequest("POST", "registration-ot-verified", data, cb);
}
export const SigninService = async (data, cb) => {
    return apiRequest("POST", "login", data, cb);
}
export const SocialLoginService = async (data, cb) => {
    return apiRequest("POST", "social-login", data, cb);
}
export const EditProfileService = async (data, cb) => {
    return apiRequest("POST", "edit-profile", data, cb);
}
